<template>
	<div class="signup-form">
		<el-tabs v-model="activeName" :stretch="true" type="border-card">
			<el-tab-pane label="中国大陆" name="mainland">
				<mainland></mainland>
			</el-tab-pane>
			<el-tab-pane label="国外、港澳台" name="otherland">
				<otherland></otherland>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import mainland from "./mainland";
import otherland from "./otherland";
export default {
	data() {
		return { activeName: "mainland" };
	},
	components: {
		mainland,
		otherland
	}
};
</script>
